import { NavLink } from "react-router-dom";

const navLinkClass = (onLanding) => ({ isActive }) =>
  `nav-link text-[11px] tracking-widest2 uppercase font-medium transition-colors whitespace-nowrap ${
    onLanding
      ? "text-ivory/90 hover:text-goldleaf"
      : "text-ink hover:text-goldleaf"
  } ${isActive ? "active text-goldleaf" : ""}`;

export default function DesktopNav({ links, onLanding }) {
  return (
    <nav className="hidden lg:flex items-center gap-6 xl:gap-10">
      {links.map((l) => (
        <NavLink
          key={l.to}
          to={l.to}
          end={l.end}
          data-testid={l.id}
          className={navLinkClass(onLanding)}
        >
          {l.label}
        </NavLink>
      ))}
    </nav>
  );
}
